module.exports = __webpack_public_path__ + "img/KL.38590116.png";